const creditApp = {
	summaryQuestiom: {
		English: 'Please, review all the information above and confirm if it matches your Driver License',
		Spanish: 'Por favor, revise toda la informacion anterior y confirme si coincide con su licencia de conducir',
	},
	termsOfUseTitle: {
		English: 'Terms, Conditions & Notices',
		Spanish: 'Términos, Condiciones y Avisos',
	},
	termsOfUseInstruction: {
		English: 'Please review the terms and conditions before proceeding.',
		Spanish: 'Por favor revise los términos y condiciones antes de continuar.',
	},
	//termsOfUseText: {
	//    //English: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur sagittis posuere interdum. Duis rutrum mattis placerat. Integer egestas convallis bibendum. Nullam sed mauris lorem. In sit amet lorem sit amet dolor mattis rhoncus. Integer lacinia pellentesque elit. Duis volutpat tortor velit, nec volutpat mauris sodales non. Donec aliquam velit mi, sit amet maximus sem varius nec. Aenean ante augue, commodo ac interdum sodales, efficitur at turpis.Pellentesque cursus at justo in mattis.Quisque luctus eleifend est, gravida viverra felis vestibulum et.Suspendisse accumsan nulla id neque mollis, et dignissim mi maximus.Vestibulum vitae viverra diam.Sed sit amet rutrum nulla.Donec varius mi eu diam efficitur ullamcorper. Aliquam erat volutpat.Sed bibendum ante consequat arcu suscipit rutrum eget ut tortor.Curabitur congue pulvinar posuere.Morbi eu elit nulla.Nunc non nibh sit amet enim imperdiet facilisis.In suscipit nec dolor vel convallis.Aliquam porta rutrum pretium. Ut accumsan ultrices justo, at pulvinar magna maximus non. Nulla blandit accumsan accumsan. Donec nec scelerisque enim. Vestibulum eget dolor sapien. Pellentesque rutrum augue turpis, at consequat risus eleifend eu. Cras vestibulum nisl sit amet erat venenatis, nec gravida mauris blandit. Phasellus dictum sollicitudin ante id egestas. In sed augue sed sapien vulputate gravida quis ac sapien.Interdum et malesuada fames ac ante ipsum primis in faucibus.Vestibulum sodales lorem felis.Praesent a erat auctor, condimentum lorem ut, accumsan odio.Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.Donec vehicula turpis faucibus venenatis fringilla.Curabitur vitae semper enim.Praesent tincidunt nunc a massa imperdiet accumsan.Morbi malesuada dolor id nunc posuere tristique.Suspendisse potenti. In consectetur orci in felis tincidunt vehicula.Integer viverra convallis elit tempus faucibus.Praesent in nisi ut risus sagittis mattis.In pharetra felis nulla, ut porta urna mollis ac.Morbi faucibus tortor at nisi facilisis, ut facilisis tellus iaculis.Nam vitae molestie metus.Quisque sed molestie risus.Ut nisi nunc, ornare eget tortor lobortis, venenatis ornare tortor.",
	//    //Spanish: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur sagittis posuere interdum. Duis rutrum mattis placerat. Integer egestas convallis bibendum. Nullam sed mauris lorem. In sit amet lorem sit amet dolor mattis rhoncus. Integer lacinia pellentesque elit. Duis volutpat tortor velit, nec volutpat mauris sodales non. Donec aliquam velit mi, sit amet maximus sem varius nec. Aenean ante augue, commodo ac interdum sodales, efficitur at turpis.Pellentesque cursus at justo in mattis.Quisque luctus eleifend est, gravida viverra felis vestibulum et.Suspendisse accumsan nulla id neque mollis, et dignissim mi maximus.Vestibulum vitae viverra diam.Sed sit amet rutrum nulla.Donec varius mi eu diam efficitur ullamcorper. Aliquam erat volutpat.Sed bibendum ante consequat arcu suscipit rutrum eget ut tortor.Curabitur congue pulvinar posuere.Morbi eu elit nulla.Nunc non nibh sit amet enim imperdiet facilisis.In suscipit nec dolor vel convallis.Aliquam porta rutrum pretium. Ut accumsan ultrices justo, at pulvinar magna maximus non. Nulla blandit accumsan accumsan. Donec nec scelerisque enim. Vestibulum eget dolor sapien. Pellentesque rutrum augue turpis, at consequat risus eleifend eu. Cras vestibulum nisl sit amet erat venenatis, nec gravida mauris blandit. Phasellus dictum sollicitudin ante id egestas. In sed augue sed sapien vulputate gravida quis ac sapien.Interdum et malesuada fames ac ante ipsum primis in faucibus.Vestibulum sodales lorem felis.Praesent a erat auctor, condimentum lorem ut, accumsan odio.Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.Donec vehicula turpis faucibus venenatis fringilla.Curabitur vitae semper enim.Praesent tincidunt nunc a massa imperdiet accumsan.Morbi malesuada dolor id nunc posuere tristique.Suspendisse potenti. In consectetur orci in felis tincidunt vehicula.Integer viverra convallis elit tempus faucibus.Praesent in nisi ut risus sagittis mattis.In pharetra felis nulla, ut porta urna mollis ac.Morbi faucibus tortor at nisi facilisis, ut facilisis tellus iaculis.Nam vitae molestie metus.Quisque sed molestie risus.Ut nisi nunc, ornare eget tortor lobortis, venenatis ornare tortor."
	//},
	loginPage: {
		quote: {
			English: 'Quote Application',
			Spanish: 'Solicitud de Cotización',
		},
		quoteCodeSendCodeNote: {
			English: 'A security code will be sent to:  ',
			Spanish: 'Se enviará un código de seguridad a: ',
		},
		verifyPhoneText: {
			English: 'Verify Phone',
			Spanish: 'Verificar Teléfono',
		},
		codeSentMessage: {
			English: 'Code Sent',
			Spanish: 'Codigo Enviado',
		},
		quoteCodeNote: {
			English: 'Please enter the security code sent to: ',
			Spanish: 'Por favor, ingrese el código de seguridad enviado a:',
		},
		quoteLoginError: {
			English: 'Verification Attempt failed. Wrong or Expired Code.',
			Spanish: 'Intento de Verificación Fallido. Código Icorrecto o Expirado.',
		},
		quoteLoginSendCodeButton: {
			English: 'Send Code',
			Spanish: 'Envia codigo',
		},
		quoteLoginButton: {
			English: 'Continue',
			Spanish: 'Continuar',
		},
		quoteLoginFormPlaceholder: {
			English: 'Security Code',
			Spanish: 'Código de Seguridad',
		},
		resendVerificationCode: {
			English: 'Resend Verification Code',
			Spanish: 'Reenviar Código de verificación',
		},
	},
	creationPage: {
		applicantInfo: {
			English: 'Applicant Info',
			Spanish: 'Información del Aplicante',
		},
		firstName: {
			English: 'First Name',
			Spanish: 'Primer Nombre',
		},
		lastName: {
			English: 'Last Name',
			Spanish: 'Apellido(s)',
		},
		dateOfBirth: {
			English: 'Date of Birth',
			Spanish: 'Fecha de Nacimiento',
		},
		dateOfBirthFormatMessage: {
			English: 'MM/DD/YYYY format is required',
			Spanish: 'MM/DD/YYYY formato es requerido',
		},
		dateOfBirthUnderageMessage: {
			English: 'You must be 18 years or older',
			Spanish: 'Debe tener 18 años o más.',
		},
		emailAddress: {
			English: 'Email Address',
			Spanish: 'Correo Electrónico',
		},
		phoneNumber: {
			English: 'Phone Number',
			Spanish: 'Número de Teléfono',
		},
		iAcknowledge: {
			English: 'I acknowledge that I have read the',
			Spanish: 'Yo afirmo que he leído la',
		},
		privacyPolicy: {
			English: 'Privacy Policy',
			Spanish: 'Póliza de Privacidad',
		},
		smsConsentButton: {
			English: 'SMS terms and conditions',
			Spanish: 'términos y condiciones de los SMS',
		},
		smsConsentText: {
			English: 'and that I consent to being contacted by texts/calls, which may be pre-recorded and via autodialer',
			Spanish: 'y doy mi consentimiento para que me contacten mediante mensajes de texto/llamadas, que pueden ser pregrabados y mediante marcador automático.',
		},
		createApplication: {
			English: 'Create Application',
			Spanish: 'Crear Aplicación',
		},
		createSuccessMessage: {
			English:
				"<strong>Congratulations, {namePrefilled}</strong> <br><br>Your quote request has been <strong>successfully submitted</strong>. <br><br> Thank you for taking this important step with <strong>{storeName}</strong>. We are committed to providing you with the best service possible and helping you find your perfect vehicle. <br><br>An email with further instructions has been sent to <strong>{emailPrefilled}</strong>. Please check your inbox and follow the instructions to proceed. <br><br>We appreciate your interest in <strong>{storeName}</strong> and are eager to assist you in your car buying journey. If you have any immediate questions or concerns, please don't hesitate to contact us at <strong>{storePhone}</strong>. <br><br>Thank you again for choosing <strong>{storeName}</strong>. We look forward to serving you soon!",
			Spanish:
				'<strong>Felicidades, {namePrefilled}</strong> <br><br>Su solicitud de cotización ha sido <strong>enviada con éxito</strong>. <br><br> Gracias por dar este importante paso con <strong>{storeName}</strong>. Estamos comprometidos a proporcionarle el mejor servicio posible y ayudarle a encontrar su vehículo perfecto. <br><br>Se ha enviado un correo electrónico con instrucciones adicionales a <strong>{emailPrefilled}</strong>. Por favor, revise su bandeja de entrada y siga las instrucciones para proceder. <br><br>Agradecemos su interés en <strong>{storeName}</strong>  y estamos ansiosos por ayudarle en su viaje de compra de un coche. Si tiene alguna pregunta o inquietud inmediata, no dude en contactarnos al <strong>{storePhone}</strong>. <br><br>Gracias nuevamente por elegir <strong>{storeName}</strong>. ¡Esperamos servirle pronto!',
		},
		createSuccessMessageInStore1: {
			English:
				'<strong>Congratulations, {namePrefilled}</strong> <br><br>Your quote request has been successfully submitted. <br><br> Thank you for taking this important step with <strong>{storeName}</strong>. We are committed to providing you with the best service possible and helping you find your perfect vehicle. <br><br>To proceed with your application, please click on the link below: <br><br>',
			Spanish:
				'<strong>Felicidades, {namePrefilled}</strong> <br><br>Su solicitud de cotización ha sido enviada con éxito. <br><br> Gracias por dar este importante paso con <strong>{storeName}</strong>. Estamos comprometidos a proporcionarle el mejor servicio posible y ayudarle a encontrar su vehículo perfecto. <br><br>Para continuar con su solicitud de cotización, por favor haga clic en el enlace a continuación: <br><br>',
		},
		createSuccessMessageInStore2: {
			English:
				"<br>We appreciate your interest in <strong>{storeName}</strong> and are eager to assist you in your car buying journey. If you have any immediate questions or concerns, please don't hesitate to contact us at <strong>{storePhone}</strong>. <br><br>Thank you again for choosing <strong>{storeName}</strong>. We look forward to serving you soon!",
			Spanish:
				'<br>Agradecemos su interés en <strong>{storeName}</strong>  y estamos ansiosos por ayudarle en su viaje de compra de un coche. Si tiene alguna pregunta o inquietud inmediata, no dude en contactarnos al <strong>{storePhone}</strong>. <br><br>Gracias nuevamente por elegir <strong>{storeName}</strong>. ¡Esperamos servirle pronto!',
		},
		startApplication: {
			English: 'Start application',
			Spanish: 'Comenzar application',
		},
		createErrorMessage: {
			English: 'Oops...',
			Spanish: 'SPANISH -- Oops...',
		},
		createErrorMessage2: {
			English: 'Something went wrong.',
			Spanish: 'lso salió mal.',
		},
		createErrorAction: {
			English: 'Get me out of here',
			Spanish: 'SPANISH -- Sáqueme de aquí',
		},
		requiredMessage: {
			English: 'This field is required',
			Spanish: 'Este campo es requerido',
		},
		nameValidationMessage: {
			English: 'The field contains special characters that are not allowed.',
			Spanish: 'El campo contiene caracteres especiales que no están permitidos.',
		},
	},
};
const validations = {};

const miscellaneous = {
	selectYear: {
		English: '-- Year --',
		Spanish: '-- Año --',
	},
	selectMonth: {
		English: '-- Month --',
		Spanish: '-- Mes --',
	},
	selectDay: {
		English: '-- Day --',
		Spanish: '-- Día --',
	},
	months: {
		English: [
			{ text: 'January', value: 1 },
			{ text: 'February', value: 2 },
			{ text: 'March', value: 3 },
			{ text: 'April', value: 4 },
			{ text: 'May', value: 5 },
			{ text: 'June', value: 6 },
			{ text: 'July', value: 7 },
			{ text: 'August', value: 8 },
			{ text: 'September', value: 9 },
			{ text: 'October', value: 10 },
			{ text: 'November', value: 11 },
			{ text: 'December', value: 12 },
		],
		Spanish: [
			{ text: 'Enero', value: 1 },
			{ text: 'Febrero', value: 2 },
			{ text: 'Marzo', value: 3 },
			{ text: 'Abril', value: 4 },
			{ text: 'Mayo', value: 5 },
			{ text: 'Junio', value: 6 },
			{ text: 'Julio', value: 7 },
			{ text: 'Agosto', value: 8 },
			{ text: 'Septiembre', value: 9 },
			{ text: 'Octubre', value: 10 },
			{ text: 'Noviembre', value: 11 },
			{ text: 'Diciembre', value: 12 },
		],
	},
	statusMessage: {
		English: 'Fafa - English',
		Spanish: 'fafa',
	},
};

const categories = {
	personal: {
		English: 'Personal',
		Spanish: 'Personal',
	},
	//incentives: {
	//    English: 'Incentives',
	//    Spanish: 'Incentivos'
	//},
	//quote: {
	//    English: 'Quote',
	//    Spanish: 'Cotización'
	//},
	creditApp: {
		English: 'Application',
		Spanish: 'Aplicacíon',
	},
	thankYou: {
		English: 'Thanks',
		Spanish: 'Gracias',
	},
};

const buttonLabels = {
	acceptTerms: {
		English: 'Accept Terms',
		Spanish: 'Aceptar los Términos',
	},
	yes: {
		English: 'Yes',
		Spanish: 'Si',
	},
	no: {
		English: 'No',
		Spanish: 'No',
	},
	yesSummary: {
		English: 'Yes',
		Spanish: 'Si',
	},
	noSummary: {
		English: 'No',
		Spanish: 'No',
	},
	continue: {
		English: 'Continue',
		Spanish: 'Continuar',
	},
	procedeWithoutPlaidLink: {
		English: "I'm unable to verify my identity at the moment.",
		Spanish: 'No puedo verificar mi identidad en este momento.',
	},
	getEstimatedQuotePerson: {
		English: 'I would prefer an inaccurate quote and to not share my social security number at this time.',
		Spanish: 'Preferiría una cotización inexacta y no compartir mi número de seguro social en este momento.',
	},
	getEstimatedQuoteBusiness: {
		English: 'I would prefer an inaccurate quote and to not share the company tax Id at this time.',
		Spanish: 'Preferiría una cotización inexacta y no compartir la identificacion tributaria de la compañía en este momento.',
	},
	none: {
		English: 'None',
		Spanish: 'Ninguno',
	},
	plate: {
		English: 'License Plate',
		Spanish: 'Número de Placa',
	},
	vin: {
		English: 'Vehicle Identification # (VIN)',
		Spanish: 'Identificación del vehículo (VIN)',
	},
	neither: {
		English: 'Neither',
		Spanish: 'Ninguno',
	},

	usePin: {
		English: 'Use this PIN',
		Spanish: 'Usar este PIN',
	},
	dontHavePin: {
		English: 'Do not have the PIN',
		Spanish: 'No tengo el PIN',
	},
	both: {
		English: 'Both',
		Spanish: 'Ambos',
	},
	myself: {
		English: 'Myself',
		Spanish: 'Yo',
	},
	child: {
		English: 'Child',
		Spanish: 'Hijo(a)',
	},
	insurance: {
		English: 'Insurance Only',
		Spanish: 'Solo Seguro',
	},
	taxes: {
		English: 'Taxes Only',
		Spanish: 'Solo Impuestos',
	},
	army: {
		//El
		English: 'Army',
		Spanish: 'Ejercito',
	},
	navy: {
		//La
		English: 'Navy',
		Spanish: 'Marina de Guerra',
	},
	airForce: {
		//La
		English: 'Air Force',
		Spanish: 'Fuerza Aerea',
	},
	nationalGuard: {
		//La
		English: 'National Guard',
		Spanish: 'Guardia National',
	},
	marines: {
		//La
		English: 'Marines',
		Spanish: 'Infantería de Marina',
	},
	coastGuard: {
		//La
		English: 'Coast Guard',
		Spanish: 'Guardia Costera',
	},
	active: {
		English: 'Active',
		Spanish: 'Activo(a)',
	},
	veteran: {
		English: 'Veteran',
		Spanish: 'Veterano(a)',
	},
	inactive: {
		English: 'Inactive',
		Spanish: 'Inactivo(a)',
	},
	reservist: {
		English: 'Reservist',
		Spanish: 'Reserva',
	},
	fullTime: {
		English: 'Full-Time',
		Spanish: 'Tiempo completo',
	},
	partTime: {
		English: 'Part-Time',
		Spanish: 'Medio Tiempo',
	},
	graduated: {
		English: 'Graduated',
		Spanish: 'Graduado',
	},
	academicLeave: {
		English: 'Academic Leave',
		Spanish: 'Licencia Académica',
	},
	highSchool: {
		English: 'High School',
		Spanish: 'Preuniversitario / Técnico Medio',
	},
	college: {
		English: 'College',
		Spanish: 'Colegio Universitario',
	},
	university: {
		English: 'University',
		Spanish: 'Universidad',
	},
	tradeSchool: {
		English: 'Trade School',
		Spanish: 'Escuela de Oficios',
	},
	registeredNursingSchool: {
		//?????????????????????????????????
		English: 'Registered Nursing School',
		Spanish: 'Escuela de Enfermería Registrada',
	},
	nursingSchool: {
		English: 'Nursing School',
		Spanish: 'Escuela de Enfermería',
	},
	nar: {
		English: 'National Association of Realtors (NAR)',
		Spanish: 'National Association of Realtors (NAR)',
		//Spanish: "Asociación Nacional de Agentes Inmobiliarios(NAR)"
	},
	ffa: {
		English: 'Future Farmers of America (FFA)',
		Spanish: 'Future Farmers of America (FFA)',
		//Spanish: "Futuros agricultores de América(FFA)"
	},
	fba: {
		English: 'Farm Bureau Association (FBA)',
		Spanish: 'Farm Bureau Association (FBA)',
		//Spanish: "Asociación de Oficinas Agrícolas(FBA)"
	},
	dfa: {
		English: 'Dairy Farmers of America (DFA)',
		Spanish: 'Dairy Farmers of America (DFA)',
		//Spanish: "Granjeros Lácteos de América(DFA)"
	},
	nari: {
		English: 'National Association of Remodelers Industry (NARI)',
		Spanish: 'National Association of Remodelers Industry (NARI)',
		//Spanish: "Asociación Nacional de la Industria de Remodeladores(NARI)"
	},
	nfib: {
		English: 'National Federation of Independent Businesses (NFIB)',
		Spanish: 'National Federation of Independent Businesses (NFIB)',
		//Spanish: "Federación Nacional de Empresas Independientes(NFIB)"
	},
	nfda: {
		English: 'National Funeral Directors Association (NFDA)',
		Spanish: 'National Funeral Directors Association (NFDA)',
		//Spanish: "Asociación Nacional de Directores de Funerarias(NFDA)"
	},
	back: {
		English: 'Back',
		Spanish: 'Atras',
	},
	own: {
		English: 'Own',
		Spanish: 'Poseo',
	},
	parents: {
		English: 'Parents',
		Spanish: 'Padres',
	},
	siblings: {
		English: 'Siblings',
		Spanish: 'Hermanos',
	},
	other: {
		English: 'Other',
		Spanish: 'Otro',
	},
	retired: {
		English: 'Retired',
		Spanish: 'Retirado(a)',
	},
	disabled: {
		English: 'Disabled',
		Spanish: 'Desabilitado(a)',
	},
	student: {
		English: 'Student',
		Spanish: 'Estudiante',
	},
	unemployed: {
		English: 'Unemployed',
		Spanish: 'Desempleado(a)',
	},
	hourly: {
		English: 'Hourly',
		Spanish: 'Por hora',
	},
	salary: {
		English: 'Salary',
		Spanish: 'Salario',
	},
	weekly: {
		English: 'Weekly',
		Spanish: 'Semanalmente',
	},
	biWeekly: {
		English: 'BiWeekly',
		Spanish: 'Quincenalmente',
	},
	monthly: {
		English: 'Monthly',
		Spanish: 'Mensualmente',
	},
	quarterly: {
		English: 'Quarterly',
		Spanish: 'Trimestralmente',
	},
	semiAnnual: {
		English: 'Semi-Annual',
		Spanish: 'Semestralmente',
	},
	annually: {
		English: 'Annually',
		Spanish: 'Anualmente',
	},
	cash: {
		English: 'Cash',
		Spanish: 'Efectivo',
	},
	finance: {
		English: 'Finance',
		Spanish: 'Financiado',
	},
	lease: {
		English: 'Lease',
		Spanish: 'Arrendamiento',
	},
	//States
	florida: {
		English: 'Florida',
		Spanish: 'Florida',
	},

	// Please briefly describe
	// Por favor describa breviamente

	//**** INFO FOR MILITARY CURRENT EMPLOYER ****
	//provideMilitaryCurrentEmployerName
	//provideMilitaryCurrentEmployerPhoneNumber
	//provideMilitaryCurrentEmployerPosition
	//provideMilitaryCurrentEmployerSupervisorName
	//provideMilitaryCurrentEmployerSupervisorPhoneNumber
	//provideMilitaryCurrentEmployerStartedDate   ***** ONLY MONTH AND YEAR

	//**** INFO FOR CURRENT EMPLOYER ****
	//provideCurrentEmployerName
	//provideCurrentEmployerPhoneNumber
	//provideCurrentEmployerPosition
	//provideCurrentEmployerSupervisorName
	//provideCurrentEmployerSupervisorPhoneNumber
	//provideCurrentEmployerStartedDate   ***** ONLY MONTH AND YEAR

	//**** INFO FOR MILITARY CURRENT EMPLOYER ****
	//providePreviousEmployerName
	//providePreviousEmployerPhoneNumber
	//providePreviousEmployerPosition
	//providePreviousEmployerStartedDate  ***** ONLY MONTH AND YEAR

	//**** INFO FOR CURRENT EMPLOYER ****
	//provideMilitaryPreviousEmployerName
	//provideMilitaryPreviousEmployerPhoneNumber
	//provideMilitaryPreviousEmployerPosition
	//provideMilitaryPreviousEmployerStartedDate  ***** ONLY MONTH AND YEAR
};

/// CUSTOMER PORTAL /////

const customerPortalNavBar = {
	garageTitle: {
		English: 'My Garage',
		Spanish: 'Mi Garaje',
	},
	profileTitle: {
		English: 'Profile',
		Spanish: 'Perfil',
	},
};

const customerPortalHomePage = {
	welcome: {
		English: 'Welcome,',
		Spanish: 'Bienvenido,',
	},
	applicationWidgetSubtextPartialCompleted: {
		English: 'Complete your application.',
		Spanish: 'Complete su aplicación.',
	},
	applicationWidgetSubtextCompletedNC: {
		English: 'See the best rates we can get you based on your credit and other factors.',
		Spanish: 'Consulte cuales son las mejores tasas según su crédito y otros factores.',
	},
	applicationWidgetTitlePartialCompleted: {
		English: 'Complete Your Profile',
		Spanish: 'Complete su Perfil.',
	},
	applicationWidgetTitleCompletedNC: {
		English: 'Credit Application',
		Spanish: 'Aplicación de Crédito',
	},
	applicationWidgetButtonTextCompleted: {
		English: 'View/Edit Application',
		Spanish: 'Ver/Editar su Aplicación',
	},
	applicationWidgetButtonTextCompletedNC: {
		English: 'Start Application',
		Spanish: 'Inicia su Aplicación',
	},
	IDVWidgetTitle: {
		English: 'Identification',
		Spanish: 'Identificación',
	},
	IDVWidgetSubtext: {
		English: 'Upload a form of identification to speed up the process.',
		Spanish: 'Suba una forma de identificación para agilizar el proceso.',
	},
	IDVWidgetButtonText: {
		English: 'Upload ID',
		Spanish: 'Subir Identificación',
	},
	businessWidgetExistsTitle: {
		English: 'Business Information',
		Spanish: 'Informacion de la Compañía',
	},
	businessWidgetTitle: {
		English: 'Add a Business',
		Spanish: 'Agregar una Compañía',
	},
	businessWidgetExistsSubtext: {
		English: 'View your business.',
		Spanish: 'Ver su compañía.',
	},
	businessWidgetSubtext: {
		English: 'Add your business for an easier check out process.',
		Spanish: 'Agrega su  para un proceso de pago más fácil.',
	},
	businessWidgetExistButtonText: {
		English: 'View Business',
		Spanish: 'Ver Compañía',
	},
	businessWidgetButtonText: {
		English: 'Add Business',
		Spanish: 'Agregar Compañía',
	},
	garageWidgetTitle: {
		English: 'My Garage',
		Spanish: 'Mi Garaje',
	},
	garageWidgetSubtext: {
		English: 'Take a look at the vehicles you own or lease.',
		Spanish: 'Consulte los vehículos que posees o arriendas.',
	},
	garageWidgetButtonText: {
		English: 'Access Garage',
		Spanish: 'Accede a su Garaje',
	},
};

const customerPortalGaragePage = {
	garagePageTitle: {
		English: 'My Garage',
		Spanish: 'Mi Garaje',
	},
	garagePageAddButtonText: {
		English: 'Add Vehicle',
		Spanish: 'Agregue Vehículo',
	},
	garageRemoveVehicleTitle: {
		English: 'Remove Vehicle',
		Spanish: 'Eliminar Vehículo',
	},
	garageRemoveVehicleSubtext: {
		English: 'Are you sure you want to remove this vehicle from your garage? This action is not reversible.',
		Spanish: '¿Estás seguro de que deseas eliminar este vehículo de su garaje? Esta acción no se puede reevertir.',
	},
	acceptText: {
		English: 'Continue',
		Spanish: 'Continuar',
	},
	cancelText: {
		English: 'Cancel',
		Spanish: 'Cancelar',
	},
	menuActionsRemovalVehicleText: {
		English: 'Remove vehicle',
		Spanish: 'Eliminar vehículo',
	},
	cardSubtextUnknown: {
		English: 'Unknown',
		Spanish: 'Desconocido',
	},
	cardSubtextSentence: {
		English: 'vehicle in garage',
		Spanish: 'vehículo en el garaje',
	},
};

const customerPortalProfilePage = {
	conditionalSectionHeaderTitle: {
		English: 'Profile Information',
		Spanish: 'Información de Perfil',
	},
	sectionsPersonalTitle: {
		English: 'Personal Information',
		Spanish: 'Información Personal',
	},
	sectionHousingTitle: {
		English: 'Housing',
		Spanish: 'Vivienda',
	},
	sectionEmploymentTitle: {
		English: 'Employment',
		Spanish: 'Empleo',
	},
	sectionBusinessTitle: {
		English: 'Business(es)',
		Spanish: 'Compañía(s)',
	},
};

const customerPortalPersonalInfoSection = {
	editSectionText: {
		English: 'Edit Section',
		Spanish: 'Editar Sección',
	},
	editSSNText: {
		English: 'Edit SSN',
		Spanish: 'Editar Número de Seguro Social',
	},
	sectionTitleText: {
		English: 'Personal Information',
		Spanish: 'Información Personal',
	},
	emailText: {
		English: 'No email provided',
		Spanish: 'No se proporcionó un correo electrónico',
	},
	nameText: {
		English: 'No name provided',
		Spanish: 'No se proporcionó un nombre',
	},
	dobText: {
		English: 'No date of birth provided',
		Spanish: 'No se proporcionó una fecha de nacimiento',
	},
	phoneText: {
		English: 'No phone provided',
		Spanish: 'No se proporcionó un teléfono',
	},
	ssnText: {
		English: 'No SSN provided',
		Spanish: 'No se proporcionó un Numero de Seguro Social',
	},
	languageText: {
		English: 'Unknown',
		Spanish: 'Desconocido',
	},
	addressText: {
		English: 'No address provided',
		Spanish: 'No se proporcionó una dirección',
	},
	submitText: {
		English: 'Submit',
		Spanish: 'Enviar',
	},
	cancelText: {
		English: 'Cancel',
		Spanish: 'Cancelar',
	},
	emailValidationText: {
		English: 'Please enter a valid email.',
		Spanish: 'Por favor, ingrese un correo electrónico válido.',
	},
	phoneValidationText: {
		English: 'Please enter a valid phone.',
		Spanish: 'Por favor, ingrese un teléfono válido.',
	},
	emailModalTitle: {
		English: 'Verify Your Email',
		Spanish: 'Verifica su correo electrónico',
	},
	emailModalSubtext: {
		English: 'Please enter the code we sent to:',
		Spanish: 'Por favor, ingrese el código que enviamos a:',
	},
	phoneModalTitle: {
		English: 'Verify Your Phone Number',
		Spanish: 'Verifica su número de teléfono',
	},
	phoneModalSubtext: {
		English: 'Please enter the code we sent to:',
		Spanish: 'Por favor, ingrese el código que enviamos a:',
	},
	emailEditPlaceholder: {
		English: 'Enter new email',
		Spanish: 'Introduce su nuevo correo electrónico',
	},
};

const customerPortalHousingInfoSection = {
	housingSectionTitle: {
		English: 'Housing',
		Spanish: 'Vivienda',
	},
	editSectionText: {
		English: 'Edit Section',
		Spanish: 'Editar Sección',
	},
	housingStatusText: {
		English: 'No status provided',
		Spanish: 'No se proporcionó un estado',
	},
	paymentAmountText: {
		English: ' payment',
		Spanish: ' pago',
	},
	paymentText: {
		English: 'No payment provided',
		Spanish: 'No se proporcionó un pago',
	},
	moveInDateText: {
		English: 'No move in date provided',
		Spanish: 'No se proporcionó una fecha de mudanza',
	},
	sinceText: {
		English: 'Since ',
		Spanish: 'Desde ',
	},
};

const customerPortalEmploymentInfoSection = {
	housingSectionTitle: {
		English: 'Employment',
		Spanish: 'Empleo',
	},
	editSectionText: {
		English: 'Edit Section',
		Spanish: 'Editar Sección',
	},
	employmentStatusText: {
		English: 'No employment status provided',
		Spanish: 'No se proporcionó un estado de empleo',
	},
	employmentNameText: {
		English: 'No employment name provided',
		Spanish: 'No se proporcionó un nombre de empleo',
	},
	employerPhoneText: {
		English: 'No employment phone provided',
		Spanish: 'No se proporcionó un teléfono de empleo',
	},
	employmentPositionText: {
		English: 'No employment position provided',
		Spanish: 'No se proporcionó un puesto de trabajo',
	},
	employmentDateText: {
		English: 'No employment dates provided',
		Spanish: 'No se proporcionaron fechas de empleo',
	},
	employmentIncomeText: {
		English: 'No employment income provided',
		Spanish: 'No se proporcionaron ingresos de empleo',
	},
};

const customerPortalBusinessSection = {
	businessSectionTitle: {
		English: 'Business(es)',
		Spanish: 'Compañía(s)',
	},
	routeToBusinessText: {
		English: 'Go to business page',
		Spanish: 'Ir a la página de la compañía',
	},
};

const customerPortalBusinessPage = {
	basicBusinessTitle: {
		English: 'Basic Business Information',
		Spanish: 'Información Básica de la Compañía',
	},
	businessOperatorTitle: {
		English: 'Business Operator',
		Spanish: 'Operador de la Compañía',
	},
	businessPrincipalTitle: {
		English: 'Business Principal',
		Spanish: 'Principal de la Compañía',
	},
};

const customerPortalBasicBusinessSection = {
	sectionTitle: {
		English: 'Business Information',
		Spanish: 'Información de la Compañía',
	},
	editSectionText: {
		English: 'Edit Section',
		Spanish: 'Editar Sección',
	},
	addressNotProvidedText: {
		English: 'No addresses provided',
		Spanish: 'No se proporcionaron direcciones',
	},
	nameText: {
		English: 'No business name provided',
		Spanish: 'No se proporcionó el nombre de la Compañía',
	},
	phoneText: {
		English: 'No phone number provided',
		Spanish: 'No se proporcionó el número de teléfono',
	},
	sinceText: {
		English: 'Since ',
		Spanish: 'Desde ',
	},
	startDateText: {
		English: 'No start date provided',
		Spanish: 'No se proporcionó la fecha de inicio',
	},
	yibText: {
		English: ' years in business',
		Spanish: ' años operando',
	},
	yearsInBusinessText: {
		English: 'Years in business not available',
		Spanish: 'Años operando no disponible',
	},
	taxIDText: {
		English: 'Tax ID: ',
		Spanish: 'Tax ID: ',
	},
	taxIDNotProvidedText: {
		English: 'No Tax ID provided',
		Spanish: 'No se proporcionó el tax ID',
	},
	monthlyProfitText: {
		English: 'Monthly Profit: ',
		Spanish: 'Ganancia Mensual: ',
	},
	monthlyProfitNotProvidedText: {
		English: 'No profit information provided',
		Spanish: 'No se proporcionó información de ganancias',
	},
	residenceStatusNotProvidedText: {
		English: 'Location ownership Status not provided ',
		Spanish: 'Location ownership status not provided ',
	},
};

const customerPortalOperatorBusinessSection = {
	sectionTitle: {
		English: 'Business Operator',
		Spanish: 'Operador de la Compañía',
	},
	editSectionText: {
		English: 'Edit Section',
		Spanish: 'Editar Sección',
	},
	addressNotProvidedText: {
		English: 'No operator address given',
		Spanish: 'No se proporcionó la dirección del operador',
	},
	nameText: {
		English: 'No operator name given',
		Spanish: 'No se proporcionó el nombre del operador',
	},
	relationshipNotProvidedText: {
		English: 'No operator relationship given',
		Spanish: 'No se proporcionó la relación del operador',
	},
	relationshipText: {
		English: 'Relationship: ',
		Spanish: 'Relación: ',
	},
};

const customerPortalPrincipalBusinessSection = {
	sectionTitle: {
		English: 'Business Principal',
		Spanish: 'Principal de la Compañía',
	},
	editSectionText: {
		English: 'Edit Section',
		Spanish: 'Editar Sección',
	},
	nameNotProvidedText: {
		English: 'No principal name given',
		Spanish: 'No se proporcionó el nombre del principal',
	},
	jobTitleNotProvidedText: {
		English: 'No principal job title provided',
		Spanish: 'No se proporcionó el puesto de trabajo principal',
	},
	percentageOfOwnerText: {
		English: 'Percentage Of Ownership: ',
		Spanish: 'Porcentaje de Propiedad: ',
	},
	percentageOfOwnerNotProvidedText: {
		English: 'No ownership percentage provided',
		Spanish: 'No se proporcionó el porcentaje de propiedad',
	},
	dobNotProvidedText: {
		English: 'No date of birth provided',
		Spanish: 'No se proporcionó fecha de nacimiento',
	},
	phoneNotProvidedText: {
		English: 'No phone number provided',
		Spanish: 'No se proporcionó el número de teléfono',
	},
	addressNotProvidedText: {
		English: 'No address provided',
		Spanish: 'No se proporcionó la dirección',
	},
};

const customerPortalIdentityVerificationPage = {
	h1VerificationNeeded: {
		English: 'Verification Needed',
		Spanish: 'Verificación Necesaria',
	},
	pStartVerification: {
		English: 'Please click the button below to start our verification process.',
		Spanish: 'Por favor, haga clic en el botón de abajo para iniciar nuestro proceso de verificación.',
	},
	h1DocumentReceived: {
		English: 'Document Received',
		Spanish: 'Documento Recibido',
	},
	pPendingVerification: {
		English: 'Pending Verification...',
		Spanish: 'Verificación Pendiente...',
	},
	//TODO: Continue checking Spanish translation from here
	pSafeToGoHome: {
		English: 'It is now safe to go back to the home page.',
		Spanish: 'Ahora es seguro volver a la página principal.',
	},
	h1VerificationFailed: {
		English: 'Verification Failed',
		Spanish: 'La Verificación Falló',
	},
	pAskRepresentative: {
		English: 'Please ask your Dealership Representative for more details.',
		Spanish: 'Por favor, consulte a su representante del concesionario para obtener más detalles.',
	},
	h1InvalidID: {
		English: 'Invalid ID.',
		Spanish: 'ID No Válido.',
	},
	homeButtonText: {
		English: 'Home',
		Spanish: 'Inicio',
	},
};

// Forms
const customerPortalAddVehicleForm = {
	radioQuestionRequired: {
		English: 'Please make a selection.',
		Spanish: 'Por favor, haga una selección.',
	},
	sectionTitle: {
		English: 'Add a New Vehicle',
		Spanish: 'Agregar Un Nuevo Vehículo',
	},
	whichQuestionText: {
		English: 'Which one of these do you have?',
		Spanish: '¿Cuales de estos tienes?',
	},
	neitherText: {
		English: 'Neither',
		Spanish: 'Ninguno',
	},
	plateStateText: {
		English: 'Plate State',
		Spanish: 'Estado de Placa',
	},
	plateText: {
		English: 'USA Plate Number',
		Spanish: 'Número de Placa De USA',
	},
	makeText: {
		English: 'Make',
		Spanish: 'Marca',
	},
	modelText: {
		English: 'Model',
		Spanish: 'Modelo',
	},
	styleText: {
		English: 'Style',
		Spanish: 'Estilo',
	},
	yearText: {
		English: 'Year',
		Spanish: 'Año',
	},
	ownershipTypeText: {
		English: 'Ownership Type',
		Spanish: 'Tipo de Propiedad',
	},
	ownerShipPlaceholderText: {
		English: 'Select Ownership Type',
		Spanish: 'Selecciona el Tipo de Propiedad',
	},
	saveText: {
		English: 'Save Vehicle',
		Spanish: 'Guardar Vehículo',
	},
	formInvalidText: {
		English: 'Please ensure all fields are entered and correct.',
		Spanish: 'Por favor, asegúrate de que todos los campos estén completos y correctos.',
	},
	vinInvalidText: {
		English: 'VIN is invalid.',
		Spanish: 'El VIN es invalido.',
	},
	vinRequiredText: {
		English: 'VIN is required.',
		Spanish: 'El VIN es obligatorio.',
	},
	plateStateRequiredText: {
		English: 'State is required.',
		Spanish: 'Estado es obligatorio.',
	},
	plateNumberRequiredText: {
		English: 'Plate number is required.',
		Spanish: 'El numero de la placa es obligatorio.',
	},
	makeRequiredText: {
		English: 'Make is required.',
		Spanish: 'La marca es obligatoria.',
	},
	modelRequiredText: {
		English: 'Model is required.',
		Spanish: 'El modelo es obligatorio.',
	},
	styleRequiredText: {
		English: 'Style is required.',
		Spanish: 'El estilo es obligatorio.',
	},
	yearRequiredText: {
		English: 'Model year is required.',
		Spanish: 'El año del modelo es obligatorio.',
	},
	yearInvalidText: {
		English: 'Model year is invalid.',
		Spanish: 'El año del modelo es invalido.',
	},
	ownershipTypeRequiredText: {
		English: 'Ownership relationship type is required.',
		Spanish: 'El tipo de propiedad es obligatorio.',
	},
};

const customerPortalAddBusinessForm = {
	sectionTitle: {
		English: 'Business Information',
		Spanish: 'Información de la Compañía',
	},
	dba: {
		English: 'DBA (Doing Business As)',
		Spanish: 'Operando Como (DBA)',
	},
	legalName: {
		English: 'Business Legal Name',
		Spanish: 'Nombre Legal de la Compañía',
	},
	entityType: {
		English: 'Entity Type',
		Spanish: 'Tipo de Entidad',
	},
	businessStartDate: {
		English: 'Business Start Date',
		Spanish: 'Fecha de Inicio de la Compañía',
	},
	businessTaxId: {
		English: 'Business Tax ID',
		Spanish: 'Tax ID de la Compañía',
	},
	grossMonthlyProfit: {
		English: 'Gross Monthly Profit of Business',
		Spanish: 'Ganancia Mensual Bruta',
	},
	email: {
		English: 'Company Email',
		Spanish: 'Email de la Compañía',
	},
	mainPhoneNumber: {
		English: "Company's Main Phone Number",
		Spanish: 'Teléfono de la Compañía',
	},
	ownershipStatus: {
		English: "Ownership Status of the Company's Location",
		Spanish: 'Estado de Propiedad de la Ubicación de la Compañía',
	},
	monthlyPayment: {
		English: 'Monthly Payment',
		Spanish: 'Pago Mensual',
	},
	addressInUS: {
		English: 'Is the company address in the US?',
		Spanish: '¿La dirección de la Compañía es en los Estados Unidos?',
	},
	yes: {
		English: 'Yes',
		Spanish: 'Si',
	},
	no: {
		English: 'No',
		Spanish: 'No',
	},
	country: {
		English: 'Country',
		Spanish: 'País',
	},
	zipCode: {
		English: 'Zip Code',
		Spanish: 'Código Postal',
	},
	streetAddress: {
		English: 'Street Address',
		Spanish: 'Dirección',
	},
	apartment: {
		English: 'Apartment/Condo/Suite',
		Spanish: 'Apartamento/Condominio/Suite',
	},
	city: {
		English: 'City',
		Spanish: 'Ciudad',
	},
	state: {
		English: 'State',
		Spanish: 'Estado',
	},
	stateProvince: {
		English: 'State/Province',
		Spanish: 'Estado/Provincia',
	},
	county: {
		English: 'County',
		Spanish: 'Condado',
	},
	operatorQuestion: {
		English: 'Are you the operator?',
		Spanish: '¿Eres el operador?',
	},
	operatorFirstName: {
		English: 'First Name of Operator',
		Spanish: 'Nombre del Operador',
	},
	operatorLastName: {
		English: 'Last Name of Operator',
		Spanish: 'Apellido del Operador',
	},
	relationshipDescription: {
		English: 'Relationship Description',
		Spanish: 'Descripción de la Relación',
	},
	principalQuestion: {
		English: 'Are you the principal of the business?',
		Spanish: '¿Eres el principal de la Compañía?',
	},
	principalFirstName: {
		English: 'First Name of Principal',
		Spanish: 'Nombre del Principal',
	},
	principalLastName: {
		English: 'Last Name of Principal',
		Spanish: 'Apellido del Principal',
	},
	principalDob: {
		English: 'Date of Birth of Principal',
		Spanish: 'Fecha de Nacimiento del Principal',
	},
	principalPhoneNumber: {
		English: 'Phone Number of Principal',
		Spanish: 'Número de Teléfono del Principal',
	},
	principalJobTitle: {
		English: 'Principal Job Title',
		Spanish: 'Título del Trabajo Principal',
	},
	principalOwnership: {
		English: "Principal's Ownership Percentage of the Company",
		Spanish: 'Porcentaje de Propiedad del Principal en la Empresa',
	},
	save: {
		English: 'Save',
		Spanish: 'Guardar',
	},

	// validation
	radioQuestionRequired: {
		English: 'Please make a selection.',
		Spanish: 'Por favor, haga una selección.',
	},
	businessTaxIdRequired: {
		English: 'Tax ID is required',
		Spanish: 'Se requiere el tax ID',
	},
	dbaRequired: {
		English: 'Please enter what the name the entity is doing business as.',
		Spanish: 'Por favor, introduzca el nombre bajo el cual opera la entidad.',
	},
	addressLine1Required: {
		English: 'Address is required.',
		Spanish: 'La dirección es obligatoria.',
	},
	cityRequired: {
		English: 'City is required.',
		Spanish: 'La ciudad es obligatoria.',
	},
	stateRequired: {
		English: 'State is required.',
		Spanish: 'El estado es obligatorio.',
	},
	zipCodeRequired: {
		English: 'Zip Code is required.',
		Spanish: 'El código postal es obligatorio.',
	},
	invalidZip: {
		English: 'Zip code is invalid.',
		Spanish: 'El código postal es invalido',
	},
	countyRequired: {
		English: 'County is required.',
		Spanish: 'El condado es obligatorio.',
	},
	legalNameRequired: {
		English: 'Legal Name is required.',
		Spanish: 'El nombre legal es obligatorio.',
	},
	businessStartDateRequired: {
		English: 'Business Start Date is required.',
		Spanish: 'La fecha de inicio de la Compañía es obligatoria.',
	},
	invalidDOBText: {
		English: 'Invalid date.',
		Spanish: 'La fecha de nacimento es invalido.',
	},
	businessStartDateInvalid: {
		English: 'Invalid date format.',
		Spanish: 'Formato de fecha no válido.',
	},
	phoneNumberRequired: {
		English: 'Phone Number is required.',
		Spanish: 'El número de teléfono es obligatorio.',
	},
	invalidPhoneNumberFormat: {
		English: 'Phone Number is invalid.',
		Spanish: 'El número de teléfono es inválido',
	},
	emailRequired: {
		English: 'Email Address is required.',
		Spanish: 'La dirección de correo electrónico es obligatoria.',
	},
	emailInvalid: {
		English: 'Must be a valid email address.',
		Spanish: 'Debe ser una dirección de correo electrónico válida.',
	},
	entityTypeRequired: {
		English: 'Entity Type is required.',
		Spanish: 'El tipo de entidad es obligatorio.',
	},
	grossMonthlyProfitRequired: {
		English: 'Monthly profit is required.',
		Spanish: 'La ganancia mensual es obligatoria.',
	},
	principalSameAsApplicantRequired: {
		English: 'Please make a selection.',
		Spanish: 'Por favor, haga una selección.',
	},
	firstNameRequired: {
		English: 'First name is required.',
		Spanish: 'El nombre es obligatorio.',
	},
	lastNameRequired: {
		English: 'Last name is required.',
		Spanish: 'El apellido es obligatorio.',
	},
	jobTitleRequired: {
		English: 'Job title is required.',
		Spanish: 'El título del trabajo es obligatorio.',
	},
	phoneNumberOperatorRequired: {
		English: 'Phone number is required.',
		Spanish: 'El número de teléfono es obligatorio.',
	},
	dateOfBirthRequired: {
		English: 'Date of birth is required.',
		Spanish: 'La fecha de nacimiento es obligatoria.',
	},
	percentageOfOwnershipRequired: {
		English: 'Percentage of ownership is required.',
		Spanish: 'El porcentaje de propiedad es obligatorio.',
	},
	operatorSameAsApplicantRequired: {
		English: 'Please make a selection.',
		Spanish: 'Por favor, haga una selección.',
	},
	firstNameOperatorRequired: {
		English: 'First name is required.',
		Spanish: 'El nombre es obligatorio.',
	},
	lastNameOperatorRequired: {
		English: 'Last name is required.',
		Spanish: 'El apellido es obligatorio.',
	},
	relationshipDescriptionOperatorRequired: {
		English: 'Relationship type is required.',
		Spanish: 'El tipo de relación es obligatorio.',
	},
};

const customerPortalResidenceStatus = {
	paymentRequired: {
		English: 'Payment amount is required.',
		Spanish: 'Pago es obligatorio.',
	},
};

const generalMessages = {
	radioQuestionRequired: {
		English: 'Please make a selection.',
		Spanish: 'Por favor, haga una selección.',
	},
	emailInvalid: {
		English: 'Must be a valid email address.',
		Spanish: 'Debe ser una dirección de correo electrónico válida.',
	},
	invalidPhoneNumberFormat: {
		English: 'Phone Number is invalid.',
		Spanish: 'El número de teléfono es inválido.',
	},

	// Address
	addressInUS: {
		English: 'Is the address in the US?',
		Spanish: '¿La dirección es en los Estados Unidos?',
	},
};

const LOCALIZATION = {
	creditApp,
	categories,
	buttonLabels,
	validations,
	miscellaneous,
	customerPortalNavBar,
	customerPortalHomePage,
	customerPortalGaragePage,
	customerPortalProfilePage,
	customerPortalPersonalInfoSection,
	customerPortalHousingInfoSection,
	customerPortalEmploymentInfoSection,
	customerPortalBusinessSection,
	customerPortalBusinessPage,
	customerPortalBasicBusinessSection,
	customerPortalOperatorBusinessSection,
	customerPortalPrincipalBusinessSection,
	customerPortalIdentityVerificationPage,
	customerPortalAddVehicleForm,
	customerPortalAddBusinessForm,
	customerPortalResidenceStatus,
	generalMessages,
};

export default LOCALIZATION;
